<section class="container">

    <form [formGroup]="formModalidadeGarantia" class="form">
        <div class="row">
            <div class="col">
                <h3>
                    Modalidade de Garantia
                </h3>
            </div>

            <div class="col-auto">
                <button class="btn btn-primary no-margin" type="button"
                    *ngIf="podeCadastrarModalidade && !modoCadastro && !modoEdicao" (click)="opcaoCadastro()"
                    [disabled]="pesquisado" ngbTooltip="Tela para cadastro de modalidade."><i
                        class="fa fa-file-signature">
                    </i> Cadastrar Nova Modalidade
                </button>

                <button type="button" class="btn btn-primary" (click)="voltarParaLista()" *ngIf="modoCadastro">
                    Voltar</button>

                <button *ngIf="modoEdicao && !modoCadastro" type="button" class="btn btn-primary"
                    (click)="desabilitarEdicao()">Cancelar</button>

                <button *ngIf="permissaoEdicao && !modoCadastro && !modoEdicao" [disabled]="pesquisado" type="button"
                    class="btn btn-primary" (click)="habilitarEdicao()">Editar
                </button>

                <button *ngIf="modoEdicao && !modoCadastro" type="button" class="btn btn-primary"
                    [disabled]="!permissaoEdicao || !formModalidadeGarantia.valid" (click)="atualizar()">Salvar
                </button>

                <button *ngIf="modoCadastro" type="button" class="btn btn-primary"
                    [disabled]="!permissaoEdicao || !formModalidadeGarantia.valid" (click)="salvar()">Salvar
                </button>
            </div>
        </div>


        <div class="row">
            <ul ngbNav #nav="ngbNav" (navChange)="onTabChange($event)" class="col nav-tabs">

                <li [ngbNavItem]="'dados básicos'" id="dados básicos" title="Dados Básicos">
                    <button ngbNavLink>Dados Básicos</button>
                    <ng-template ngbNavContent>
                        <div class="row">
                            <div class="bn-form-group col-md-1">
                                <label class="form-label"><b>Ident:</b></label>
                                <input class="form-control" name="id" ngDefaultControl formControlName="id">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Nome:</b></label>
                                <input class="form-control" name="nome" ngDefaultControl formControlName="nome">
                            </div>
                            <div class="bn-form-group col-md-2">
                                <label class="form-label"><b>Sigla: <i class="fa fa-question-circle help-subtitulo"
                  placement="bottom"
                  ngbTooltip="Preencher apenas com letras, números. Invés de espaços utilize hífen."></i> </b></label>
                                <input class="form-control" name="nome" ngDefaultControl formControlName="sigla">
                            </div>
                            <div class="bn-form-group col-md-6">
                                <label class="form-label"><b>Descrição:</b></label>
                                <input class="form-control" name="descricao" ngDefaultControl
                                    formControlName="descricao">
                            </div>
                        </div>
                        <div class="row">
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>CNPJ responsável pelo fundo:</b></label>
                                <input class="form-control" name="cnpj" ngDefaultControl
                                    formControlName="cnpjResponsavelFundo" bnMask="CNPJ">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Data res. dir. criação do fundo.: <i
                                            class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Data resolução diretoria criação do fundo"></i> </b></label>
                                <bn-datepicker name="dataResolucaoDiretoriaCriacaoFundo" ngDefaultControl
                                    formControlName="dataResolucaoDiretoriaCriacaoFundo">
                                </bn-datepicker>
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Data limite ult. amortização: <i
                                            class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="A data limite de última amortização permitida para as operações nesta modalidade (se aplicável)"></i></b></label>
                                <bn-datepicker name="dataLimiteUltimaAmortizacao" ngDefaultControl
                                    formControlName="dataLimiteUltimaAmortizacao">
                                </bn-datepicker>
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Nome valor crédito: </b></label>
                                <input class="form-control" name="nomeValorCredito" ngDefaultControl
                                    formControlName="nomeValorCredito">
                            </div>
                        </div>
                        <div class="row">
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Prazo máx. env. lib. op. giro em dias: <i
                                            class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Prazo máximo envio liberação operação giro em dias"></i>
                                    </b></label>
                                <input class="form-control" name="prazoMaximoEnvioLiberacaoOperacoesGiroEmDias"
                                    ngDefaultControl formControlName="prazoMaximoEnvioLiberacaoOperacoesGiroEmDias">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>E-mail do administrador: </b></label>
                                <input class="form-control" name="emailAdministrador" ngDefaultControl
                                    formControlName="emailAdministrador">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Número dec. dir. criação fundo.: <i
                                            class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Número decisão diretoria para criaç. de fundo:"></i></b></label>
                                <input class="form-control" name="numeroDecisaoDiretoriaCriacaoFundo" ngDefaultControl
                                    formControlName="numeroDecisaoDiretoriaCriacaoFundo">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Cod. eve. IPD: <i
                                            class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Código do evento para verificação de impedimentos no sistema IPD"></i></b></label>
                                <input class="form-control" name="codigoEventoIpd" ngDefaultControl
                                    formControlName="codigoEventoIpd">
                            </div>
                        </div>
                        <div class="row">
                            <div class="bn-form-group col-md-4">
                                <label class="form-label"><b>Número Contábil Confronto Honra Crédito Livre:</b></label>
                                <input class="form-control" name="numeroContaContabilConfrontoHonraCreditoLivre"
                                    ngDefaultControl formControlName="numeroContaContabilConfrontoHonraCreditoLivre">
                            </div>
                            <div class="bn-form-group col-md-4">
                                <label class="form-label"><b>Número Contábil Confronto Honra Repasse:</b></label>
                                <input class="form-control" name="numeroContaContabilConfrontoHonraRepasse"
                                    ngDefaultControl formControlName="numeroContaContabilConfrontoHonraRepasse">
                            </div>
                            <div class="bn-form-group col-md-4">
                                <label class="form-label"><b>Tipo cálculo limite Beneficiário</b></label>
                                <select type="text" id="idTipoCalculoLimiteBeneficiario" class="form-select"
                                    formControlName="idTipoCalculoLimiteBeneficiario"
                                    [attr.disabled]="!modoEdicao ? true : null">
                                    <option [value]="opcao.numero"
                                        *ngFor="let opcao of opcoesTipoCalculoLimiteBeneficiario">
                                        {{opcao.numero}} - {{opcao.nome}}
                                    </option>
                                </select>
                            </div>

                        </div>
                        <div class="row">
                            <div class="bn-form-group col-md-4">
                                <label class="form-label"><b>Identificador Banco Empresa:</b></label>
                                <input class="form-control" name="identificadorBancoEmpresaSap" ngDefaultControl
                                    formControlName="identificadorBancoEmpresaSap">
                            </div>
                            <div class="bn-form-group col-md-4">
                                <label class="form-label"><b>Identificador Coordenadas Conta:</b></label>
                                <input class="form-control" name="identificadorCoordenadasContaSap" ngDefaultControl
                                    formControlName="identificadorCoordenadasContaSap">
                            </div>
                            <div class="bn-form-group col-md-4">
                                <label class="form-label"><b>Identificador Fin. Pagamento Honra </b></label>
                                <input class="form-control" name="identificadorFinalidadeTedPagamentoHonraSap"
                                    ngDefaultControl formControlName="identificadorFinalidadeTedPagamentoHonraSap">
                            </div>
                            <div class="bn-form-group col-md-4">
                                <label class="form-label"><b>Tipo de Conglomerado: <i
                                            class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Indica se a modalidade de garantia possui opção de Conglomerado Financeiro para o Agente Financeiro com a utilização do valor de Subscrição de Cotas na apuração automática do percentual de participação no Conglomerado ou com indicação manual do percentual de participação no Conglomerado"></i></b></label>
                                <select type="text" id="idTipoConglomerado" class="form-select"
                                    formControlName="idTipoConglomerado" [attr.disabled]="!modoEdicao ? true : null">
                                    <option [value]="null">Nenhum</option>
                                    <option [value]="opcao.numero" *ngFor="let opcao of opcoesTiposConglomerados">
                                        {{opcao.numero}} - {{opcao.nome}}
                                    </option>
                                </select>
                            </div>
                            <div class="bn-form-group col-md-4">
                              <label class="form-label"><b> Identificador finalidade Pagamento ECG por Terceiros </b></label>
                              <input class="form-control" name="identificadorFinalidadeTedPagamentoEcgTerceirosSap"
                                   ngDefaultControl formControlName="identificadorFinalidadeTedPagamentoEcgTerceirosSap">
                            </div>
                        </div>
                        <div class="row">
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Aceita operação de Crédito Livre:</b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="aceitaOperacaoCreditoLivre" ngDefaultControl
                                    formControlName="aceitaOperacaoCreditoLivre">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Aceita operação Repasse SCC-15:</b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="aceitaOperacaoRepasseSistema15" ngDefaultControl
                                    formControlName="aceitaOperacaoRepasseSistema15">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Aceita operação Repasse SCC-89:</b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="aceitaOperacaoRepasseSistema89" ngDefaultControl
                                    formControlName="aceitaOperacaoRepasseSistema89">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Aceita modalidade de giro:</b></label>
                                <input type="checkbox" class="form-check checkbox-gigante" name="aceitaModalidadeGiro"
                                    ngDefaultControl formControlName="aceitaModalidadeGiro">
                            </div>

                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Aceita modalidade de investimento:</b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="aceitaModalidadeInvestimento" ngDefaultControl
                                    formControlName="aceitaModalidadeInvestimento">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Aceita Benef. PF - Crédito Livre:</b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="aceitaBeneficiarioPessoaFisicaCreditoLivre" ngDefaultControl
                                    formControlName="aceitaBeneficiarioPessoaFisicaCreditoLivre">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Aceita Benef. PF - Repasse:</b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="aceitaBeneficiarioPessoaFisicaRepasse" ngDefaultControl
                                    formControlName="aceitaBeneficiarioPessoaFisicaRepasse">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Aceita cadastro de PL:
                                        <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Permite cadastro de Patrimônio Líquido do fundo"></i></b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="aceitaPatrimonioLiquido" ngDefaultControl
                                    formControlName="aceitaPatrimonioLiquido">
                            </div>

                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Aceita Habilitação Alternativa:
                                        <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Indica se a modalidade de garantia possui opção de Habilitação Alternativa para o Agente Financeiro"></i>
                                    </b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="aceitaHabilitacaoAlternativa" ngDefaultControl
                                    formControlName="aceitaHabilitacaoAlternativa">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Aceita Subscrição de Cotas:
                                        <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Indica se a modalidade de garantia possui opção de Subscrição de Cotas para o Agente Financeiro"></i>
                                    </b></label>
                                <input type="checkbox" class="form-check checkbox-gigante" name="aceitaSubscricaoCota"
                                    ngDefaultControl formControlName="aceitaSubscricaoCota">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Aceita Renúncia à Cob. Máx. de Ina:
                                        <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Indica se a modalidade de garantia possui opção para o AF realizar a Renúncia à Cobertura Máxima de Inadimplência do limite disponível existente na sua carteira"></i>
                                    </b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="utilizaRemuneracaoCoberturaMaxima" ngDefaultControl
                                    formControlName="utilizaRemuneracaoCoberturaMaxima">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Aceita alteração no Percentual Garantido:
                                        <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Indica se a modalidade irá permitir a mudança do Percentual Garantido por meio de aditivo"></i>
                                    </b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="aceitaAlteracaoPercentualGarantido" ngDefaultControl
                                    formControlName="aceitaAlteracaoPercentualGarantido">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Utiliza taxa de atualização da garantia:
                                        <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Indicador da taxa de atualização da garantia para cálculo de remuneração"></i>
                                    </b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="utilizaTaxaAtualizacaoGarantia" ngDefaultControl
                                    formControlName="utilizaTaxaAtualizacaoGarantia">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Utiliza SCR:
                                        <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Utiliza dados SCR na validação de solicitação de honra"></i></b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="utilizaDadosScrNaValidacaoDeSolicitacaoHonra" ngDefaultControl
                                    formControlName="utilizaDadosScrNaValidacaoDeSolicitacaoHonra">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Cálculo tx. equivalente: <i
                                            class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Realiza cálculo de taxas equivalentes"></i></b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="realizaCalculoTaxasEquivalentes" ngDefaultControl
                                    formControlName="realizaCalculoTaxasEquivalentes">
                            </div>

                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>API externa habilitada: <i
                                            class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Indica se a API externa do Sistema está habilitada ou não para esta modalidade."></i></b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="aceitaUtilizacaoApiExternaFg2" ngDefaultControl
                                    formControlName="aceitaUtilizacaoApiExternaFg2">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Necessário tratamento lim. contrat.: <i
                                            class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Indica se o valor total do limite de contratação informado para as cestas desta modalidade necessita ser tratado pelo sistema (adição do valor das honras e subtração do valor das recuperações) ou se deverá ser utilizado tal qual informado."></i></b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="necessarioTratarValorTotalDosRecursosDaTranche" ngDefaultControl
                                    formControlName="necessarioTratarValorTotalDosRecursosDaTranche">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Permite aditivo subs. de beneficiário:</b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="permiteAditivoSubstituicaoBeneficiario" ngDefaultControl
                                    formControlName="permiteAditivoSubstituicaoBeneficiario">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Cobrança ECG ativa: <i class="fa fa-question-circle help-subtitulo"
                  placement="bottom"
                  ngbTooltip="Campo é selecionado automaticamente de acordo com o preenchimento da 'Data Início Cobrança ECG' na aba 'Cestas'"></i></b></label>
                                <input type="checkbox" class="form-check checkbox-gigante" name="cobrancaEcgEstaAtiva"
                                    ngDefaultControl formControlName="cobrancaEcgEstaAtiva" readonly="true">
                            </div>

                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Utiliza relatórios PENG:</b></label>
                                <input type="checkbox" class="form-check checkbox-gigante" name="utilizaRelatorioPENG"
                                    ngDefaultControl formControlName="utilizaRelatorioPENG">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Utiliza relatórios Saldo Garantido:</b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="utilizaRelatorioSaldoGarantido" ngDefaultControl
                                    formControlName="utilizaRelatorioSaldoGarantido">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Usa atual. info. acomp. proc.:</b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="utilizaAtualizacaoInformacaoAcompanhamentoProcessual" ngDefaultControl
                                    formControlName="utilizaAtualizacaoInformacaoAcompanhamentoProcessual">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Utiliza atualização info. class. risco:</b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="utilizaAtualizacaoInformacaoClassificacaoRisco" ngDefaultControl
                                    formControlName="utilizaAtualizacaoInformacaoClassificacaoRisco">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Utiliza remun. validação lim. fundo:</b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="utilizaRemuneracaoValidacaoLimiteFundo" ngDefaultControl
                                    formControlName="utilizaRemuneracaoValidacaoLimiteFundo">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Mostra Limite AF na Cesta
                                        <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Mostrar o limite do AF e valor disponível para contratatação na tela de limites (cesta). Atenção: Este atributo não tem efeito sobre a validação."></i>

                                    </b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="existeLimiteAgenteFinanceiroTranche" ngDefaultControl
                                    formControlName="existeLimiteAgenteFinanceiroTranche">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Utiliza Limites de Aporte AF:
                                        <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Aporte do AF para cálculo do limite."></i>

                                    </b></label>
                                <input type="checkbox" class="form-check checkbox-gigante" name="usaLimiteAporte"
                                    ngDefaultControl formControlName="usaLimiteAporte">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Utiliza CNAE grandes empresas:
                                        <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Indica se a modalidade vai operar com CNAEs de grandes empresas."></i>

                                    </b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="utilizaCnaesGrandesEmpresas" ngDefaultControl
                                    formControlName="utilizaCnaesGrandesEmpresas">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Utiliza limite no Risco de Crédito?
                                    <i class="fa fa-question-circle help-subtitulo"
                                    placement="bottom"
                                    ngbTooltip="Para contratação de operação, sistema verifica se o AF possui LIMITE APROVADO válido no sistema Risco de Crédito (N06)"></i>
                              </b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="utilizaLimiteRiscoCredito" ngDefaultControl
                                    formControlName="utilizaLimiteRiscoCredito">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Utiliza Empresas Bloqueadas?
                                        <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Indica se a modalidade de garantia possui opção para o AF realizar consulta de impedimento de contratação por CNPJ do Tomador do Crédito."></i>

                                    </b></label>
                                <input type="checkbox" class="form-check checkbox-gigante"
                                    name="utilizaEmpresasBloqueadas" ngDefaultControl
                                    formControlName="utilizaEmpresasBloqueadas">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Utiliza Leilão?
                                        <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Indica se a modalidade de garantia possui Leilão de créditos não recuperados."></i>

                                    </b></label>
                                <input type="checkbox" class="form-check checkbox-gigante" name="utilizaLeilao"
                                    ngDefaultControl formControlName="utilizaLeilao">
                            </div>
                            <div class="bn-form-group col-md-3">
                                <label class="form-label"><b>Realiza upload docs acompanhamento?
                                <i class="fa fa-question-circle help-subtitulo"
                                    placement="bottom"
                                    ngbTooltip="Indica se a modalidade permite fazer o upload no FG2 das declarações semestrais e do relatório anual de auditoria exigidos no Regulamento."></i>

                                </b></label>
                                <input type="checkbox" class="form-check checkbox-gigante" name="realizaUploadDocsAcompanhamento"
                  ngDefaultControl formControlName="realizaUploadDocsAcompanhamento">
              </div>
              <div class="bn-form-group col-md-3">
                <label class="form-label"><b>Utiliza Pagamento de ECG por Terceiros?
                  <i class="fa fa-question-circle help-subtitulo"
                      placement="bottom"
                      ngbTooltip="Indicador da utilização de Pagamento de ECG por Terceiros na modalidade."></i>

                </b></label>
                <input type="checkbox" class="form-check checkbox-gigante" name="utilizaPagamentoDeEcgPorTerceiros"
                  ngDefaultControl formControlName="utilizaPagamentoDeEcgPorTerceiros">
              </div>
           </div>
        <div class="row">
            <div class="bn-form-group col-md-12">
                <label class="form-label"><b>Mensagem aviso SCR: </b></label>
                <textarea rows="5" class="form-control" name="mensagemAvisoScr" ngDefaultControl
                    formControlName="mensagemAvisoScr"></textarea>
            </div>
        </div>

        <div class="row">
            <div class="bn-form-group col-md-3">
                <label class="form-label" for="estiloMenu"><b>Estilo do menu lateral:</b></label>
                <select id="estiloMenu" *ngIf="modoEdicao|| podeCadastrarModalidade; else modoCadastro"
                    class="form-control" name="estiloMenu" formControlName="estiloMenu">
                    <option [ngValue]=cor.codigo *ngFor="let cor of tipoEstiloMenu">
                        {{cor.codigo}}
                    </option>
                </select>
                <ng-template #modoCadastro>
                    <input id="estiloMenu" class="form-control" name="estiloMenu" formControlName="estiloMenu">
                </ng-template>
            </div>



        </div>

        <div class="row">
            <div class="bn-form-group col-md-12">
                <label class="form-label"><b>Observação limite total:</b></label>
                <textarea rows="6" class="form-control" name="textoObservacaoLimiteTotal" ngDefaultControl
                    formControlName="textoObservacaoLimiteTotal"></textarea>
            </div>
        </div>

        <div class="row">
            <div class="bn-form-group col-md-12">
                <label class="form-label"><b>Termos de contratação:</b></label>
                <textarea rows="6" class="form-control" name="termosContratacao" ngDefaultControl
                  formControlName="textoTermosContratacao"></textarea>
              </div>
            </div>

            <div class="row">
              <div class="bn-form-group col-md-12">
                <label class="form-label"><b>Termos envio devolução honra:</b></label>
                <textarea rows="6" class="form-control" name="textoTermosEnvioDevolucaoHonra" ngDefaultControl
                  formControlName="textoTermosEnvioDevolucaoHonra"></textarea>
              </div>
            </div>

            <div class="row">
              <div class="bn-form-group col-md-12">
                <label class="form-label"><b>Termos envio devolução honra:</b></label>
                <textarea rows="6" class="form-control" name="textoTermosEnvioDevolucaoHonra" ngDefaultControl
                  formControlName="textoTermosEnvioDevolucaoHonra"></textarea>
              </div>
            </div>

        <div class="row">
            <div class="bn-form-group col-md-12">
                <label class="form-label"><b>Termos Renúncia à Cobertura Máxima de Inadimplência:</b></label>
                <textarea rows="6" class="form-control" name="textoTermoRemuneracaoCoberturaMaxima" ngDefaultControl
                    formControlName="textoTermoRemuneracaoCoberturaMaxima"></textarea>
            </div>
        </div>

        <div class="row">
            <div class="bn-form-group col-md-12">
                <label class="form-label"><b>Termos Empresas Bloqueadas:</b></label>
                <textarea rows="6" class="form-control" name="textoTermoEmpresasBloqueadas" ngDefaultControl
                    formControlName="textoTermoEmpresasBloqueadas"></textarea>
            </div>
        </div>

        <div class="row">
            <div class="bn-form-group col-md-12">
              <label class="form-label"><b>Termos Informe de Liquidação: *</b></label>
              <textarea rows="6" class="form-control" name="textoTermoInformeLiquidacao" ngDefaultControl
                formControlName="textoTermoInformeLiquidacao"></textarea>
            </div>
          </div>

        <div class="row">
            <div class="bn-form-group col-md-12">
              <label class="form-label"><b>Termos Renúncia Limite Adicional:</b></label>
              <textarea rows="6" class="form-control" name="textoTermoRenunciaLimiteAdicional" ngDefaultControl
                formControlName="textoTermoRenunciaLimiteAdicional"></textarea>
            </div>
          </div>

        </ng-template>
        </li>

        <li [ngbNavItem]="'histórico'" id="histórico" title="Histórico">
            <button ngbNavLink>Histórico</button>
            <ng-template ngbNavContent>
                <bn-paginacao id="ngHistorico" [total]="countHistoricos" [tamanhoPagina]="atributosPaginacao.pageSize"
                    [numPagina]="atributosPaginacao.page" [opcoesTamanhoPagina]="opcoesPaginacao"
                    (aoMudar)="mudancaPagina($event)">
                    <div class="table-responsive">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th class="removeTopBorder" scope="col"><b>ID</b></th>
                                    <th class="removeTopBorder" scope="col"><b>Data</b></th>
                                    <th class="removeTopBorder" scope="col"><b>Usuário responsável</b></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of listaHistoricos" [routerLink]="" id="pointer"
                                    (click)="buscarHistorico(item.id)">
                                    <td>{{item.id}}</td>
                                    <td>{{item.dataCriacao | date: 'dd/MM/yy HH:mm'}}</td>
                                    <td>{{item.usuarioResponsavel}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </bn-paginacao>
            </ng-template>
        </li>

        <li [ngbNavItem]="'configuração ECG'" id="configuração ECG" title="Configuração ECG">
            <button ngbNavLink>Configuração ECG</button>
            <ng-template ngbNavContent>
                <div class="alert alert-info container" *ngIf="model.configuracaoEcg == null; else mostraECG">
                    Não existe dados de Configuração ECG para esta modalidade
                </div>
                <ng-template #mostraECG>
                    <div class="row">
                        <div class="bn-form-group col-md-4">
                            <label class="form-label"><b>Id. BNDES Online ECG somado ao saldo: <i
                                        class="fa fa-question-circle help-subtitulo" placement="bottom"
                                        ngbTooltip="Identificador tipo ECG Repasse somado ao saldo "></i></b></label>
                            <input class="form-control" name="ideTipoEcgRepasseSomadoAoSaldo" ngDefaultControl
                                formControlName="ideTipoEcgRepasseSomadoAoSaldo">
                        </div>
                        <div class="bn-form-group col-md-4">
                            <label class="form-label"><b>Id. BNDES Online ECG incluido no saldo: <i
                                        class="fa fa-question-circle help-subtitulo" placement="bottom"
                                        ngbTooltip="Identificador tipo ECG Repasse incluído no saldo"></i></b></label>
                            <input class="form-control" name="ideTipoEcgRepasseIncluidoNoSaldo" ngDefaultControl
                                formControlName="ideTipoEcgRepasseIncluidoNoSaldo">
                        </div>
                        <div class="bn-form-group col-md-4">
                            <label class="form-label"><b>Id. BNDES Online ECG via boleto: <i
                                        class="fa fa-question-circle help-subtitulo" placement="bottom"
                                        ngbTooltip="Identificador tipo ECG de Repasse via boleto a ser pago pelo Agente Financeiro"></i></b></label>
                            <input class="form-control" name="ideTipoEcgRepasseBoletoRepassadoAoCliente"
                                ngDefaultControl formControlName="ideTipoEcgRepasseBoletoRepassadoAoCliente">
                        </div>
                        <div class="bn-form-group col-md-4">
                            <label class="form-label"><b>Id. BNDES Online ECG pago por terceiros: <i
                                            class="fa fa-question-circle help-subtitulo" placement="bottom"
                                            ngbTooltip="Identificador tipo ECG de Repasse pago por terceiros"></i></b></label>
                            <input class="form-control" name="ideTipoEcgRepassePagoPorTerceiros" ngDefaultControl
                                formControlName="ideTipoEcgRepassePagoPorTerceiros">
                        </div>
                        <div class="bn-form-group col-md-4">
                            <label class="form-label"><b>Tipo contrato SCC Crédito Livre: <i
                                        class="fa fa-question-circle help-subtitulo" placement="bottom"
                                        ngbTooltip="Código tipo de contrato SCC de Crédito Livre"></i></b></label>
                            <input class="form-control" name="codigoTipoContratoEcgCreditoLivre" ngDefaultControl
                                formControlName="codigoTipoContratoEcgCreditoLivre">
                        </div>
                        <div class="bn-form-group col-md-4">
                            <label class="form-label"><b>Tipo contrato SCC Repasse: <i
                                        class="fa fa-question-circle help-subtitulo" placement="bottom"
                                        ngbTooltip="Código tipo de contrato SCC de Repasse. Aplica-se apenas se houver cobranca de ECG de Repasse via boleto"></i></b></label>
                            <input class="form-control" name="codigoTipoContratoEcgRepasse" ngDefaultControl
                                formControlName="codigoTipoContratoEcgRepasse">
                        </div>
                        <div *ngIf="modalidade.cobrancaEcgEstaAtiva" class="bn-form-group col-md-4">
                            <label class="form-label"><b>UM relatório Repasse: <i
                                        class="fa fa-question-circle help-subtitulo" placement="bottom"
                                        ngbTooltip="Identificador unidade monetária relatório de Repasse ECG para operações de Repasse"></i></b></label>
                            <input class="form-control"
                                name="ideUnidadeMonetariaRelatorioRepasseEcgParaOperacoesRepasse" ngDefaultControl
                                formControlName="ideUnidadeMonetariaRelatorioRepasseEcgParaOperacoesRepasse">
                        </div>
                        <div *ngIf="modalidade.cobrancaEcgEstaAtiva" class="bn-form-group col-md-4">
                            <label class="form-label"><b>Valor da alíquota fixa do ECG (se aplicável): <i
                                        class="fa fa-question-circle help-subtitulo" placement="bottom"
                                        ngbTooltip="Valor da alíquota do ECG. Aplica-se apenas aos casos em que há uma alíquota fixa."></i></b></label>
                            <input class="form-control" name="valorAliquotaFixa" bnMask="MOEDA" ngDefaultControl
                                formControlName="valorAliquotaFixaEcg">
                        </div>
                        <div class="bn-form-group col-md-4">
                            <label class="form-label"><b>Permite alterar valor aditivo: <i
                                        class="fa fa-question-circle help-subtitulo" placement="bottom"
                                        ngbTooltip="Permite que aditivos alterem valor"></i></b></label>
                            <input type="checkbox" class="form-check checkbox-gigante" name="alteraValorEcgEmAditivo"
                                ngDefaultControl formControlName="alteraValorEcgEmAditivo">
                        </div>
                    </div>
                </ng-template>
            </ng-template>
        </li>

        <li [ngbNavItem]="'configuração eventos SCC'" id="configuração eventos SCC" title="Configuração Eventos SCC">
            <button ngbNavLink>Configuração Eventos SCC</button>
            <ng-template ngbNavContent>
                <h5 class="tituloSCC">ECG</h5>
                <div class="row">
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento retenção Repasse:</b></label>
                        <input class="form-control" name="codigoEventoRetencaoECGRepasse" ngDefaultControl
                            formControlName="codigoEventoRetencaoECGRepasse">
                    </div>
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento estorno Repasse:</b></label>
                        <input class="form-control" name="codigoEventoEstornoRetencaoECGRepasse" ngDefaultControl
                            formControlName="codigoEventoEstornoRetencaoECGRepasse">
                    </div>
                </div>
                <div class="row">
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento Crédito Livre cobrado:</b></label>
                        <input class="form-control" name="codigoEventoECGCreditoLivreCobrado" ngDefaultControl
                            formControlName="codigoEventoECGCreditoLivreCobrado">
                    </div>
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento estorno Crédito Livre cobrado:</b></label>
                        <input class="form-control" name="codigoEventoEstornoECGCreditoLivreCobrado" ngDefaultControl
                            formControlName="codigoEventoEstornoECGCreditoLivreCobrado">
                    </div>
                </div>
                <div class="row">
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento Repasse cobrado:</b></label>
                        <input class="form-control" name="codigoEventoECGRepasseCobrado" ngDefaultControl
                            formControlName="codigoEventoECGRepasseCobrado">
                    </div>
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento estorno Repasse cobrado:</b></label>
                        <input class="form-control" name="codigoEventoEstornoECGRepasseCobrado" ngDefaultControl
                            formControlName="codigoEventoEstornoECGRepasseCobrado">
                    </div>
                </div>

                <h5 class="tituloSCC">Honra</h5>
                <div class="row">
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento honra Crédito Livre:</b></label>
                        <input class="form-control" name="codigoEventoHonraCreditoLivre" ngDefaultControl
                            formControlName="codigoEventoHonraCreditoLivre">
                    </div>
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento honra pagamento parcelas vencidas Repasse:</b></label>
                        <input class="form-control" name="codigoEventoHonraPagamentoParcelasVencidas" ngDefaultControl
                            formControlName="codigoEventoHonraPagamentoParcelasVencidas">
                    </div>
                </div>
                <div class="row">
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento honra liquidação saldo vincendo Repasse:</b></label>
                        <input class="form-control" name="codigoEventoHonraLiquidacaoSaldoVincendo" ngDefaultControl
                            formControlName="codigoEventoHonraLiquidacaoSaldoVincendo">
              </div>
              <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento honra liquidação saldo vincendo no contrato original
                                Repasse:</b></label>
                        <input class="form-control" name="codigoEventoHonraLiquidacaoSaldoVincendoNoContratoOriginal"
                            ngDefaultControl
                            formControlName="codigoEventoHonraLiquidacaoSaldoVincendoNoContratoOriginal">
                    </div>
                </div>
                <div class="row">
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento estorno de honra Repasse:</b></label>
                        <input class="form-control" name="codigoEventoEstornoHonraRepasse" ngDefaultControl
                            formControlName="codigoEventoEstornoHonraRepasse">
                    </div>
                </div>

                <h5 class="tituloSCC">Recuperação de Crédito</h5>
                <div class="row">
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento recuperação crédito histórico Repasse:</b></label>
                        <input class="form-control" name="codigoEventoRecuperacaoCreditoHistoricoRepasse"
                            ngDefaultControl formControlName="codigoEventoRecuperacaoCreditoHistoricoRepasse">
                    </div>
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento estorno recuperação crédito histórico Repasse:</b></label>
                        <input class="form-control" name="codigoEventoEstornoRecuperacaoCreditoHistoricoRepasse"
                            ngDefaultControl formControlName="codigoEventoEstornoRecuperacaoCreditoHistoricoRepasse">
                    </div>
                </div>
                <div class="row">
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento recuperação crédito histórico Crédito Livre:</b></label>
                        <input class="form-control" name="codigoEventoRecuperacaoCreditoHistoricoCreditoLivre"
                            ngDefaultControl formControlName="codigoEventoRecuperacaoCreditoHistoricoCreditoLivre">
                    </div>
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento estorno recuperação crédito histórico Crédito
                                Livre:</b></label>
                        <input class="form-control" name="codigoEventoEstornoRecuperacaoCreditoHistoricoCreditoLivre"
                            ngDefaultControl
                            formControlName="codigoEventoEstornoRecuperacaoCreditoHistoricoCreditoLivre">
                    </div>
                </div>
                <div class="row">
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento recuperação crédito atualizado:</b></label>
                        <input class="form-control" name="codigoEventoRecuperacaoCreditoAtualizacao" ngDefaultControl
                            formControlName="codigoEventoRecuperacaoCreditoAtualizacao">
                    </div>
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento estorno recuperação crédito com atualização:</b></label>
                        <input class="form-control" name="codigoEventoEstornoRecuperacaoCreditoAtualizacao"
                            ngDefaultControl formControlName="codigoEventoEstornoRecuperacaoCreditoAtualizacao">
                    </div>
                </div>
                <div class="row">
                    <div class="bn-form-group col-md-4">
                        <label class="form-label"><b>Evento recuperação crédito remuneração:</b></label>
                        <input class="form-control" name="codigoEventoRecuperacaoCreditoRemuneracao" ngDefaultControl
                            formControlName="codigoEventoRecuperacaoCreditoRemuneracao">
                    </div>
                    <div class="bn-form-group col-md-4">
                        <label class="form-label"><b>Evento estorno recuperação crédito remuneração:</b></label>
                        <input class="form-control" name="codigoEventoEstornoRecuperacaoCreditoRemuneracao"
                            ngDefaultControl formControlName="codigoEventoEstornoRecuperacaoCreditoRemuneracao">
                    </div>
                    <div class="bn-form-group col-md-4">
                        <label class="form-label"><b>Evento recuperação crédito multa:</b></label>
                        <input class="form-control" name="codigoEventoRecuperacaoCreditoMulta" ngDefaultControl
                            formControlName="codigoEventoRecuperacaoCreditoMulta">
                    </div>
                </div>

                <h5 class="tituloSCC" *ngIf="modalidade && modalidade.utilizaLeilao">Leilão</h5>
                <div class="row" *ngIf="modalidade && modalidade.utilizaLeilao">
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento Leilão Repasse:</b></label>
                        <input class="form-control" name="codigoEventoLeilaoRepasse" ngDefaultControl
                            formControlName="codigoEventoLeilaoRepasse">
                    </div>
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento leilão crédito livre:</b></label>
                        <input class="form-control" name="codigoEventoLeilaoCreditoLivre" ngDefaultControl
                            formControlName="codigoEventoLeilaoCreditoLivre">
                    </div>
                </div>
                <div class="row" *ngIf="modalidade && modalidade.utilizaLeilao">
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento remuneração leilão:</b></label>
                        <input class="form-control" name="codigoEventoRemuneracaoLeilao" ngDefaultControl
                            formControlName="codigoEventoRemuneracaoLeilao">
                    </div>
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento baixa leilão repasse:</b></label>
                        <input class="form-control" name="codigoEventoBaixaLeilaoRepasse" ngDefaultControl
                            formControlName="codigoEventoBaixaLeilaoRepasse">
                    </div>
                </div>
                <div class="row" *ngIf="modalidade && modalidade.utilizaLeilao">
                    <div class="bn-form-group col-md-4">
                        <label class="form-label"><b>Evento baixa leilão crédito livre:</b></label>
                        <input class="form-control" name="codigoEventoBaixaLeilaoCreditoLivre" ngDefaultControl
                            formControlName="codigoEventoBaixaLeilaoCreditoLivre">
                    </div>
                    <div class="bn-form-group col-md-4">
                        <label class="form-label"><b>Evento estorno leilão repasse:</b></label>
                        <input class="form-control" name="codigoEventoEstornoLeilaoRepasse" ngDefaultControl
                            formControlName="codigoEventoEstornoLeilaoRepasse">
                    </div>
                    <div class="bn-form-group col-md-4">
                        <label class="form-label"><b>Evento estorno leilão crédito livre:</b></label>
                        <input class="form-control" name="codigoEventoEstornoLeilaoCreditoLivre" ngDefaultControl
                            formControlName="codigoEventoEstornoLeilaoCreditoLivre">
                    </div>
                    <div class="bn-form-group col-md-4">
                        <label class="form-label"><b>Evento estorno remuneração leilão:</b></label>
                        <input class="form-control" name="codigoEventoEstornoRemuneracaoLeilao" ngDefaultControl
                            formControlName="codigoEventoEstornoRemuneracaoLeilao">
                    </div>
                    <div class="bn-form-group col-md-4">
                        <label class="form-label"><b>Evento estorno baixa leilão repasse:</b></label>
                        <input class="form-control" name="codigoEventoEstornoBaixaLeilaoRepasse" ngDefaultControl
                            formControlName="codigoEventoEstornoBaixaLeilaoRepasse">
                    </div>
                    <div class="bn-form-group col-md-4">
                        <label class="form-label"><b>Evento estorno baixa leilão crédito livre::</b></label>
                        <input class="form-control" name="codigoEventoEstornoBaixaLeilaoCreditoLivre" ngDefaultControl
                            formControlName="codigoEventoEstornoBaixaLeilaoCreditoLivre">
                    </div>
                </div>

                <h5 class="tituloSCC">Reversão de Honra</h5>
                <div class="row">
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento reversão honra histórico Repasse:</b></label>
                        <input class="form-control" name="codigoEventoReversaoHonraHistoricoRepasse" ngDefaultControl
                            formControlName="codigoEventoReversaoHonraHistoricoRepasse">
                    </div>
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento estorno reversão honra histórico Repasse:</b></label>
                        <input class="form-control" name="codigoEventoEstornoReversaoHonraHistoricoRepasse"
                            ngDefaultControl formControlName="codigoEventoEstornoReversaoHonraHistoricoRepasse">
                    </div>
                </div>
                <div class="row">
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento reversão honra histórico Crédito Livre:</b></label>
                        <input class="form-control" name="codigoEventoReversaoHonraHistoricoCreditoLivre"
                            ngDefaultControl formControlName="codigoEventoReversaoHonraHistoricoCreditoLivre">
                    </div>
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento estorno reversão honra histórico Crédito Livre:</b></label>
                        <input class="form-control" name="codigoEventoEstornoReversaoHonraHistoricoCreditoLivre"
                            ngDefaultControl formControlName="codigoEventoEstornoReversaoHonraHistoricoCreditoLivre">
                    </div>
                </div>
                <div class="row">
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento reversão honra com atualização:</b></label>
                        <input class="form-control" name="codigoEventoReversaoHonraAtualizacao" ngDefaultControl
                            formControlName="codigoEventoReversaoHonraAtualizacao">
                    </div>
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Evento estorno reversão honra com atualização:</b></label>
                        <input class="form-control" name="codigoEventoEstornoReversaoHonraAtualizacao" ngDefaultControl
                            formControlName="codigoEventoEstornoReversaoHonraAtualizacao">
                    </div>
                </div>
                <div class="row">
                    <div class="bn-form-group col-md-4">
                        <label class="form-label"><b>Evento reversão honra remuneração:</b></label>
                        <input class="form-control" name="codigoEventoReversaoHonraRemuneracao" ngDefaultControl
                            formControlName="codigoEventoReversaoHonraRemuneracao">
                    </div>
                    <div class="bn-form-group col-md-4">
                        <label class="form-label"><b>Evento estorno reversão honra remuneração:</b></label>
                        <input class="form-control" name="codigoEventoEstornoReversaoHonraRemuneracao" ngDefaultControl
                            formControlName="codigoEventoEstornoReversaoHonraRemuneracao">
                    </div>
                    <div class="bn-form-group col-md-4">
                        <label class="form-label"><b>Evento reversão honra com multa:</b></label>
                        <input class="form-control" name="codigoEventoReversaoHonraMulta" ngDefaultControl
                            formControlName="codigoEventoReversaoHonraMulta">
                    </div>
                </div>

            </ng-template>
        </li>

        <li [ngbNavItem]="'cobrança'" id="cobrança" title="Cobrança">
            <button ngbNavLink>Cobrança</button>
            <ng-template ngbNavContent>

                <!--div class="row">
              <div class="bn-form-group col-md-3">
                <label class="form-label"><b>Lim. pag. devolução de honra: <i
                  class="fa fa-question-circle help-subtitulo" placement="bottom"
                  ngbTooltip="Quantidade de dias limite após o vencimento para pagamento de boleto de devolução de honra."></i>
                </b></label>
                <input class="form-control" name="limitePagamentoDevolucaoHonra" ngDefaultControl
                  formControlName="limitePagamentoDevolucaoHonra">
              </div>
            </div-->

                <div class="row">
                    <div class="bn-form-group col-md-2">
                        <label class="form-label"><b>Cód. coord. ficha cob.:</b></label>
                        <input class="form-control" name="codigoCoordenacaoFichaCobranca" ngDefaultControl
                            formControlName="codigoCoordenacaoFichaCobranca">
                    </div>
                    <div class="bn-form-group col-md-2">
                        <label class="form-label"><b>Cód. mod. ficha cob.:</b></label>
                        <input class="form-control" name="codigoModalidadeFichaCobranca" ngDefaultControl
                            formControlName="codigoModalidadeFichaCobranca">
                    </div>
                    <div class="bn-form-group col-md-2">
                        <label class="form-label"><b>Cód. fonte recursos:</b></label>
                        <input class="form-control" name="codigoFonteRecursos" ngDefaultControl
                            formControlName="codigoFonteRecursos">
                    </div>
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Cód. tipo de contrato de honra:</b></label>
                        <select class="form-select" name="codigoTipoContratoHonra" ngDefaultControl
                            formControlName="codigoTipoContratoHonra">
                            <option [ngValue]="null"></option>
                            <option *ngFor="let valor of dominio.tiposContratoFichaCobranca" [ngValue]="valor.codigo">
                                {{valor.codigo}} - {{valor.descricao}}</option>
                        </select>

                    </div>
                </div>

                <h5 class="faixaContratos">Faixa de Contratos</h5>
                <div class="table-responsive">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th scope="col"><b>Código tipo operação</b></th>
                                <th scope="col"><b>Código tipo de contrato</b></th>
                                <th scope="col"><b>Inicio faixa contratos</b></th>
                                <th scope="col"><b>Fim faixa contratos</b></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of model.faixasDeContratos">
                                <td>{{labelOperacao(item.codigoTipoOperacao)}}</td>
                                <td>{{item.codigoTipoContratoScc}}</td>
                                <td>{{item.inicioFaixaContratos}}</td>
                                <td>{{item.fimFaixaContratos}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-template>
        </li>

        <li [ngbNavItem]="'inadimplencia_af'" id="inadimplencia_af" title="Inadimplência AF">
            <button ngbNavLink>Inadimplência AF</button>
            <ng-template ngbNavContent>
                <div class="table-responsive mt-3">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th class="removeTopBorder" scope="col">
                                    <div class="head-table">
                                        <div>
                                            <b>Modalidades para validação de inadimplência técnica&ensp;</b>
                                            <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                                ngbTooltip="Modalidades nas quais deve ser verificada existência de inadimplência técnica do Agente Financeiro.">
                                            </i>
                                        </div>
                                        <button type="button" class="btn btn-success no-margin"
                                            (click)="adicionarModalidadeInadimplenciaTecnica()"
                                            *ngIf="permissaoEdicao && !modoCadastro && !modoEdicao">
                                            Adicionar Modalidade
                                        </button>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let item of siglasModalidadesValidacaoInadimplenciaTecnica">
                            <td>{{item}}</td>
                        </tbody>
                    </table>
                </div>
                <div class="table-responsive">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th class="removeTopBorder" scope="col">
                                    <div class="head-table">
                                        <div>
                                            <b>Modalidades para validação de inadimplência financeira&ensp;</b>
                                            <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                                ngbTooltip="Modalidades nas quais deve ser verificada existência de inadimplência financeira do Agente Financeiro.">
                                            </i>
                                        </div>
                                        <button type="button" class="btn btn-success no-margin"
                                            (click)="adicionarModalidadeInadimplenciaFinanceira()"
                                            *ngIf="permissaoEdicao && !modoCadastro && !modoEdicao">
                                            Adicionar Modalidade
                                        </button>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let item of siglasModalidadesValidacaoInadimplenciaFinanceira">
                            <td>{{item}}</td>
                        </tbody>
                    </table>
                </div>
                <div class="row realizaValidacao">
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Validação de inadimplência financeira do AF com o FGI tradicional
                                (Sistema
                                legado):</b></label>
                        <input type="checkbox" class="form-check checkbox-gigante"
                            name="realizaValidacaoInadimplenciaFinanceiraNoFgiTradicional" ngDefaultControl
                            formControlName="realizaValidacaoInadimplenciaFinanceiraNoFgiTradicional">
                    </div>
                </div>
            </ng-template>
        </li>

        <li [ngbNavItem]="'inadimplencia_beneficiario'" id="inadimplencia_beneficiario"
            title="Inadimplência Beneficiário">
            <button ngbNavLink>Inadimplência Beneficiário</button>
            <ng-template ngbNavContent>
                <div class="table-responsive mt-3">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th class="removeTopBorder" scope="col">
                                    <div class="head-table">
                                        <div>
                                            <b>Modalidades para validação de inadimplência financeira
                                                (beneficiário)&ensp;</b>
                                            <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                                ngbTooltip="Modalidades nas quais deve ser verificada existência de inadimplência financeira de beneficiário.">
                                            </i>
                                        </div>
                                        <button type="button" class="btn btn-success no-margin"
                                            (click)="adicionarModalidadeInadimplenciaBeneficiario()"
                                            *ngIf="permissaoEdicao && !modoCadastro && !modoEdicao">
                                            Adicionar Modalidade
                                        </button>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let item of siglasModalidadesValidacaoInadimplenciaBeneficiario">
                            <td>{{item}}</td>
                        </tbody>
                    </table>
                </div>
                <div class="row realizaValidacao">
                    <div class="bn-form-group col-md-6">
                        <label class="form-label"><b>Validação de inadimplência financeira do Beneficiário com o FGI
                                tradicional (Sistema
                                legado):</b></label>
                        <input type="checkbox" class="form-check checkbox-gigante"
                            name="realizaValidacaoInadimplenciaBeneficiarioNoFgiTradicional" ngDefaultControl
                            formControlName="realizaValidacaoInadimplenciaBeneficiarioNoFgiTradicional">
                    </div>
                </div>
            </ng-template>
        </li>

        <li [ngbNavItem]="'outras garantias'" id="outras garantias" title="Outras Garantias">
            <button ngbNavLink>Outras Garantias</button>
            <ng-template ngbNavContent>
                <div class="table-responsive">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th class="removeTopBorder" scope="col">
                                    <div class="head-table">
                                        <b>Outras garantias permitidas</b>
                                        <button type="button" class="btn btn-success no-margin"
                                            (click)="adicionarGarantia()"
                                            *ngIf="permissaoEdicao && !modoCadastro && !modoEdicao">
                                            Adicionar Garantia
                                        </button>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let item of dominio.tiposOutrasGarantias">
                            <td>{{item.descricao}}</td>
                        </tbody>
                    </table>
                </div>

            </ng-template>
        </li>

        <li [ngbNavItem]="'contas'" id="contas" title="Contas">
            <button ngbNavLink>Contas</button>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="bn-form-group col-md-3">
                        <label class="form-label"><b>Conta pagamento de honra: <i
                                    class="fa fa-question-circle help-subtitulo" placement="bottom"
                                    ngbTooltip="Número da conta de contrapartida para pagamentos de honras"></i></b></label>
                        <input class="form-control" name="numeroContaContrapartidaPagamentoHonra" ngDefaultControl
                            formControlName="numeroContaContrapartidaPagamentoHonra">
                    </div>
                    <div class="bn-form-group col-md-3">
                        <label class="form-label"><b>Conta recursos cobertura garantia: <i
                                    class="fa fa-question-circle help-subtitulo" placement="bottom"
                                    ngbTooltip="Número referente a conta de recursos de cobertura de garantia"></i></b></label>
                        <input class="form-control" name="numeroContaRecursosCoberturaGarantia" ngDefaultControl
                            formControlName="numeroContaRecursosCoberturaGarantia">
                    </div>
                    <div class="bn-form-group col-md-3">
                        <label class="form-label"><b>Conta recebimento de ECG: <i
                                    class="fa fa-question-circle help-subtitulo" placement="bottom"
                                    ngbTooltip="Número da conta de contrapartida para recebimento de ECGs"></i></b></label>
                        <input class="form-control" name="numeroContaContrapartidaRecebimentoEcg" ngDefaultControl
                            formControlName="numeroContaContrapartidaRecebimentoEcg">
                    </div>
                    <div class="bn-form-group col-md-3">
                        <label class="form-label"><b>Conta recebimento de Rec. de Crédito: <i
                                    class="fa fa-question-circle help-subtitulo" placement="bottom"
                                    ngbTooltip="Número da conta de contrapartida para recebimento de Recuperações de Crédito"></i></b></label>
                        <input class="form-control" name="numeroContaContrapartidaRecebimentoRecuperacaoCredito" ngDefaultControl
                            formControlName="numeroContaContrapartidaRecebimentoRecuperacaoCredito">
                    </div>
                </div>
            </ng-template>
        </li>

        <li [ngbNavItem]="'percentuais garantidos'" id="percentuais garantidos" title="Percentuais Garantidos">
            <button ngbNavLink>Percentuais Garantidos</button>
            <ng-template ngbNavContent>
                <div class="table-responsive">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th class="removeTopBorder" scope="col">
                                    <div class="head-table">
                                        <b>Percentuais Garantidos Permitidos</b>
                                        <button type="button" class="btn btn-success no-margin"
                                            (click)="adicionarPercentualGarantido()"
                                            *ngIf="permissaoEdicao && !modoCadastro && !modoEdicao">
                                            Adicionar Percentual
                                        </button>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let item of percentuaisGarantiaPermitidos">
                            <td>{{item}}
                            </td>
                        </tbody>
                    </table>
                </div>
            </ng-template>
        </li>

        <!-- Taxa de Atualização de Garantia - CL -->
        <li [ngbNavItem]="'taxaAtualizacaoGarantia'"
            *ngIf="modalidade && modalidade.utilizaTaxaAtualizacaoGarantia" title="Taxa de Atualização de Garantia - CL">
            <button ngbNavLink>Taxa de Atualização de Garantia - CL</button>
            <ng-template ngbNavContent>
                <div class="mt-2 mb-2 d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-end">
                        <input type="checkbox" class="form-check checkbox-gigante" name="verTaxasDesativadas"
                            [(ngModel)]="verTaxasDesativadas" [ngModelOptions]="{standalone: true}"
                            (change)="changeVerTaxasDesativadas()">
                        <label for="verTaxasDesativadas" class="ms-2 form-label"><b>Ver taxas desativadas</b></label>
                    </div>
                    <button type="button" class="btn btn-success no-margin" (click)="adicionarTaxaAtualizacaoGarantia()"
                        [disabled]="!permissaoEdicao">
                        Adicionar % Taxa de Garantia
                    </button>
                </div>
                <div *ngIf="taxasAtualizacaoGarantia" class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th class="removeTopBorder" scope="col">
                                    <div class="head-table">
                                        <b>Data Inicial Validade</b>
                                    </div>
                                </th>
                                <th class="removeTopBorder" scope="col">
                                    <div class="head-table">
                                        <b>Data Final Validade</b>
                                    </div>
                                </th>
                                <th class="removeTopBorder" scope="col">
                                    <div class="head-table">
                                        <b>Modalidade</b>
                                    </div>
                                </th>
                                <th class="removeTopBorder" scope="col">
                                    <div class="head-table">
                                        <b>{{indexadorText}}</b>
                                    </div>
                                </th>
                                <th class="removeTopBorder" scope="col">
                                    <div class="head-table">
                                        <b>% Taxa de Garantia</b>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let item of taxasAtualizacaoGarantia">
                            <tr [ngClass]="{'table-active' : tagInativa(item)}">
                                <td>{{item?.dataInicioValidade | date: 'dd/MM/yyyy'}}</td>
                                <td>{{item?.dataFinalValidade | date: 'dd/MM/yyyy'}}</td>
                                <td>{{item?.descModalidade}}</td>
                                <td>{{item?.descIndexador}}</td>
                                <td>
                                    {{item?.taxaGarantia+'%'}}
                                    <i *ngIf="podeExcluirTAG(item) && permissaoEdicao"
                                        class="fa fa-trash cursor-pointer text-danger ms-4"
                                        (click)="modalConfirmarExclusao($event, item.id)" placement="left-center"
                                        ngbTooltip="Exclui a vigência do % Taxa de atualização de garantia.">
                                    </i>
                                    <i *ngIf="podeEncerrarTAG(item) && permissaoEdicao"
                                        class="fa fa-ban cursor-pointer text-primary ms-4"
                                        (click)="modalEncerrarTAG(item)" placement="left-center"
                                        ngbTooltip="Encerrar vigência do % Taxa de atualização de garantia.">
                                    </i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-template>
            <ng-template #msgTemplateExcluir>
                <span>Esta ação irá excluir o % da taxa de atualização da garantia selecionado.</span>
                <br />
                <br />
                <b>Você confirma?</b>
                <br />
            </ng-template>
            <ng-template #botoesPersonalizadosExcluir>
                <button class="btn btn-md btn-success" (click)="excluirTAG()">
                    Sim
                </button>
                <button class="btn btn-md btn-danger" (click)="fecharModalExcluirTAG()">
                    Não
                </button>
            </ng-template>
        </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </div>
    </form>
    <app-modalidade-garantia-historico [modalidade]="modalidade" [historico]="historico"
        (fechaHistorico)="fecharHistorico()" *ngIf="pesquisado && abaAtiva==='histórico' && historico">
    </app-modalidade-garantia-historico>
</section>
